import {
  cta_buttonPrimaryBackground,
  text_colorTextPrimary,
} from 'ext-ui/style/colors'
import { spacing } from 'ext-ui/style/spacing'
import { css } from 'styled-components'

export default css`
  display: flex;
  flex-direction: row;
  gap: ${spacing(4)};
  font-size: 14px;

  .icon-column {
    display: flex;
    flex-direction: column;
  }

  .content-column {
    display: flex;
    flex-direction: column;
    gap: ${spacing(2)};
  }

  .title {
    font-weight: bold;
    color: ${text_colorTextPrimary};
  }

  .link {
    color: ${cta_buttonPrimaryBackground};
    text-decoration: underline;
  }
`
